import { render, staticRenderFns } from "./Secured.vue?vue&type=template&id=da227faa"
import script from "./Secured.vue?vue&type=script&lang=js"
export * from "./Secured.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports